import { ContextMenu } from 'react-contextmenu';
import { getThemeProp, theme } from 'theme';
import styled from 'styled-components';

export const SContextMenu = styled(ContextMenu)`
  background-color: ${getThemeProp('colors.white', theme)};
  border-radius: 3px;
  box-shadow: 5px 10px 20px 0 rgba(0, 0, 0, 0.19);
  min-width: 148px;
  padding: 8px 0;
  z-index: 9;

  .react-contextmenu-item {
    cursor: pointer;
    align-items: center;
    font-size: 13px;
    font-weight: 300;
    color: ${getThemeProp('colors.fiordGrey', theme)};
    display: flex;
    height: 28px;
    padding: 0 16px;

    &:hover {
      background-color: ${getThemeProp('colors.havelockBlue', theme)};
      color: ${getThemeProp('colors.white', theme)};
    }
  }
`;

export const SContainerSoftActions = styled.div`
  border-bottom: 1px solid ${getThemeProp('colors.mercuryGrey', theme)};
  padding-bottom: 8px;
  margin-bottom: 8px;
`;

export const SContainerHardActions = styled.div`
  padding-top: 8px;
`;

export const Input = styled.input`
  border: none;
  font-weight: 400;
  outline: none;
`;

export const SIconContainer = styled.div`
  display: flex;
  flex: 0 0 auto;
  margin-right: 10px;

  & > *:last-of-type {
    margin-left: 5px;
  }
`;

export const ColorContainer = styled.div`
  &:nth-child(even) {
    background-color: ${getThemeProp('colors.wildSandGrey2', theme)};
  }

  &:hover {
    background-color: ${getThemeProp('colors.solitudeGrey', theme)};
    cursor: pointer;
  }
`;

interface ListItemProps {
  depth: number;
  bgColor?: string;
}

export const ListItemContainer = styled.div`
  padding: 12px 0 12px ${({ depth }: ListItemProps) => 20 + depth * 40}px;
  margin: 0;
  list-style: none;
  font-weight: 300;
  height: 40px;
  display: flex;
  align-items: center;

  & > :last-child {
    height: 16px;
    color: ${getThemeProp('colors.fiordGrey', theme)};
    font-size: 13px;
    letter-spacing: 0.1px;
    line-height: 16px;
  }
`;
